import { memo } from 'react';
import Typography from '../../../../../../../../../../../../components/Typography/Typography';
import LangEnum from '../../../../../../../../../../../../lang/LangEnum';
import { validateTouchEnabled } from '../../../../../../../../../../../../utils/validators';
import { useTranslation } from '../../../../../../../../../../../translation/TranslationContext';
import SelloutDistributionQuantityInputTextField from '../../../../distribution/components/quantityInput/components/SelloutDistributionQuantityInputTextfield';
import SelloutDistributionTouchQuantityInput from '../../../../distribution/components/quantityInput/components/SelloutDistributionTouchQuantityInput';
import SelloutLeftColumnsRow from './SelloutLeftColumnsRow';

interface SelloutLeftColumnsDistributionRowProps {
  pieces: number;
  disabled: boolean;
  onChangePieces: (value: number) => void;
}

const SelloutLeftColumnsDistributionRow = ({
  pieces,
  disabled,
  onChangePieces,
}: SelloutLeftColumnsDistributionRowProps) => {
  const { translate } = useTranslation();

  return (
    <SelloutLeftColumnsRow
      Title={
        <Typography color="primary" noWrap>
          {translate(LangEnum.GLOBAL_NEW_ORDER)}
        </Typography>
      }
      Value={
        validateTouchEnabled() ? (
          <SelloutDistributionTouchQuantityInput
            pieces={pieces}
            disabled={disabled}
            onChangePieces={onChangePieces}
          />
        ) : (
          <SelloutDistributionQuantityInputTextField
            pieces={pieces}
            disabled={disabled}
            onChangePieces={onChangePieces}
          />
        )
      }
    />
  );
};

export default memo(SelloutLeftColumnsDistributionRow);
